import { render, staticRenderFns } from "./SlideSpalProcess.vue?vue&type=template&id=ba23e9de&scoped=true"
import script from "./SlideSpalProcess.vue?vue&type=script&lang=js"
export * from "./SlideSpalProcess.vue?vue&type=script&lang=js"
import style0 from "./SlideSpalProcess.vue?vue&type=style&index=0&id=ba23e9de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba23e9de",
  null
  
)

export default component.exports